import FeedbackBanner from './FeedbackBanner';

export default FeedbackBanner;
